import { gql } from "urql"

export default gql`
  mutation ($sourceUserId: ID!, $matchUserId: ID!) {
    matchUser(tutorId: $sourceUserId, studentId: $matchUserId) {
      student {
        id
        showPath
        fullName
        lastName
        tutorToStudentPhoneNumber(tutorId: $sourceUserId)
        studentToTutorPhoneNumber(tutorId: $sourceUserId)
      }
    }
  }
`
